import dynamic from 'next/dynamic';

import { Modal } from '~components/Modals/Base';
import type { TModalProps } from '~components/Modals/types';

const Content = dynamic(
	() => import('./dynamicContent').then((mod) => mod.Content),
	{
		ssr: false,
	}
);

export const NavigationDrawer = ({ open, locked, onClose }: TModalProps) => {
	return (
		<Modal
			open={open}
			locked={locked}
			onClose={onClose}
			data-name="navigation-drawer-modal"
		>
			<Content open={open} onClose={onClose} locked={locked} />
		</Modal>
	);
};
